import facebookColor from '../../../assets/images/icons/facebook/flogo_RGB_HEX-144.png';
import facebookWhite from '../../../assets/images/icons/facebook/flogo-HexRBG-Wht-144.png';

import instagramColor from '../../../assets/images/icons/instagram/IG_Glyph_Fill.png';
import instagramWhite from '../../../assets/images/icons/instagram/glyph-logo_May2016.png';

import linkedinColor from '../../../assets/images/icons/linkedin/In-2C-128px-R.png';
import linkedinWhite from '../../../assets/images/icons/linkedin/In-White-128px-R.png';

import youtubeColor from '../../../assets/images/icons/youtube/youtube_social_icon_red.png';
import youtubeWhite from '../../../assets/images/icons/youtube/youtube_social_icon_dark.png';

export const SOCIAL_MEDIA_CONFIG = [
	{
		img: {
			color: facebookColor,
			iconColor: facebookColor,
			white: facebookWhite,
		},
		alt: 'Bezoek ons op Facebook',
		href: 'https://www.facebook.com/aertechbvba/',
		color: '#4267B2',
		className: 'facebook-icon-offset',
	},
	{
		img: {
			color: linkedinColor,
			iconColor: linkedinColor,
			white: linkedinWhite,
		},
		alt: 'Bezoek ons op Linkedin',
		href: 'https://www.linkedin.com/company/aertech/',
		color: '#0e76a8',
	},
	{
		img: {
			color: instagramWhite,
			iconColor: instagramColor,
			white: instagramWhite,
		},
		alt: 'Bezoek ons op Instagram',
		href: 'https://www.instagram.com/aertech_bvba/?hl=nl',
		color: 'radial-gradient(circle at 30% 107%, #fdf497 0%, #fdf497 5%, #fd5949 45%,#d6249f 60%,#285AEB 90%',
	},
	{
		img: {
			color: youtubeColor,
			iconColor: youtubeColor,
			white: youtubeWhite,
		},
		alt: 'Bezoek ons Youtube kanaal',
		href: 'https://www.youtube.com/channel/UCYJ2OY76DrELFAHTGUjt8SQ',
		color: '#FF0000',
	},
];



// WEBPACK FOOTER //
// ./src/components/molecules/social-media/social-media.config.js